<template>
    <section class="indicators-data" :title="data.title">
        <span>{{ data.name }}</span>
        <span v-if="data.unit !== '%'">{{ data.value | dataformat }}<i>{{ data.unit }}</i></span>
        <span v-if="data.unit === '%'">{{ data.value | percentformat }}<i>{{ data.unit }}</i></span>
        <span v-if="data.compareInfo">{{ data.compareInfo }}</span>
        <span :class="compare_color" title="较上一周期">{{ compare_format }}</span>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .indicators-data {
        display: inline-block;
        &:nth-of-type(n+2) {
            margin-left: 5%;
        }
        > span {
            display: block;
            width: 100%;
            &:nth-child(1) {
                font-size: 14px;
                color: #142c3d;
            }
            &:nth-child(2) {
                font-size: 34px;
                i {
                    font-style: normal;
                    font-size: 16px;
                }
            }
            &:nth-child(3) {
                font-size: 12px;
                color: #93999f;
            }
            &:nth-last-child(1) {
                font-size: 12px;
                color: #FFF;
                width: 60px;
                height: 18px;
                line-height: 18px;
                text-align: center;
                border-radius: 100px;
                margin-top: 5px;
                &.red-1 {
                    background-image: linear-gradient(245deg, #ff4116, #ff2851);
                    box-shadow: 0 0 8px 0 rgba(255, 52, 51, 0.22);
                }
                &.green-1 {
                    background-image: linear-gradient(245deg, #0cde65, #2dd58a);
                    box-shadow: 0 0 8px 0 rgba(173, 249, 212, 0.79);
                }
                &.gray-1 {
                    background-color: #d4d4d4;
                }
            }
        }
    }
</style>

<script>
    import percentformat from '../../filters/percent-format'
    import dataformat from '../../filters/data-format'

    export default {
	    filters: {
		    percentformat,
		    dataformat
	    },
        data () {
            return {}
        },
        computed: {
        	// 格式化百分比数据
	        compare_format () {
	            let str = '';
	            if (percentformat(this.data.compare) === '--') {
	                str = '--';
                } else {
                    if (this.data.compare >= 0) {
                        str = '+' + percentformat(this.data.compare) + '%';
                    } else {
                        str = percentformat(this.data.compare) + '%';
                    }
                }
                return str;
            },

            compare_color () {
	            let value = this.data.compare;
                if (isNaN(value) || value === null || value === '') {
                    return {
                        'gray-1': true
                    };
                } else if (value >= 0) {
                    return {
                        'red-1': true
                    };
                } else {
                    return {
                        'green-1': true
                    };
                }
            }
        },
        props: ["data"]
    }
</script>






// WEBPACK FOOTER //
// IndicatorsData.vue?5728ec2c